import { TemplateType } from "../enums/template-type";
import { Template } from "../models/Template";

export function isAutomationTemplate(template: Template) {
  if ([
    TemplateType.ProductFollowup,
    TemplateType.ReminderRebook,
    TemplateType.ReminderAppointment,
    TemplateType.ReminderVaccination,
    TemplateType.ReminderParasiticide,
    TemplateType.ReminderHealthCarePlan,
    TemplateType.ReminderHealthCarePlanFollowUp,
    TemplateType.ReminderPreOperation,
    TemplateType.ReminderPostOperation,
    TemplateType.ReminderPayment,
  ].includes(template.type)) {
    return true;
  }

  return false;
}
